<div class="row">
  <div class="col-sm-8">
    <app-card
      [title]="'admin.service.request.view.info_title'|translate"
      [advanceButton]="true"
      [advancedButtons]="[moreButton]"
      (outputButtonAdvance)="calFunction($event)"
    >
      <table *ngIf="request.orderItemProducts?.length" class="mx-2">
        <tr>
          <td width="150">{{'doctrine.attributes.collection' | translate}}</td>
          <td>{{ request.orderItemProducts[0].orderItem?.collection?.name }}</td>
        </tr>
        <tr>
          <td>{{'doctrine.attributes.model' | translate}}</td>
          <td>{{ request.orderItemProducts[0].orderItem?.model?.name }}</td>
        </tr>
      </table>
      <div [@openClose]="showMore" class="overflow-hidden">
        <div *ngFor="let productItem of request.orderItemProducts;let j=index;" class="m-t-15">
          <p class="m-b-5 px-2">{{'admin.order.element' | translate}} {{j + 1}}</p>
          <div class="element-card px-2">
            <table>
              <tr>
                <td width="150">{{'doctrine.attributes.product' | translate}}</td>
                <td>{{$any(productItem.product)?.name}}</td>
              </tr>
              <tr *ngIf="!isRugProduct(productItem)">
                <td>{{'doctrine.attributes.fabric' | translate}}</td>
                <td>
                  <ng-container *ngFor="let fabric of productItem.orderItemProductFabricCollections; let last = last">
                    {{fabric | FabricFormat}}{{last ? '' : ' | '}}
                  </ng-container>
                </td>
              </tr>
              <!--a rug has no fabric: show what identifies it instead (D9)-->
              <ng-container *ngIf="isRugProduct(productItem)">
                <tr *ngIf="carpetSizeLabel(productItem.widthCm, productItem.lengthCm) as sizeLabel">
                  <td>{{'admin.dealer.order.carpet_size' | translate}}</td>
                  <td>{{sizeLabel}}</td>
                </tr>
                <!-- INERT until the API serializes the options — see the back-office twin.
                     OrderItemOptions has no attribute in this screen's serializer groups,
                     so each row arrives as {}. The Carpet size row above does render. -->
                <tr *ngIf="rugOptionName(productItem, CARPET_ROLE_SHAPE) as shapeName">
                  <td>{{carpetRoleLabelKey(CARPET_ROLE_SHAPE) | translate}}</td>
                  <td>{{shapeName}}</td>
                </tr>
                <tr *ngIf="rugOptionName(productItem, CARPET_ROLE_FINISHING) as finishingName">
                  <td>{{carpetRoleLabelKey(CARPET_ROLE_FINISHING) | translate}}</td>
                  <td>{{finishingName}}</td>
                </tr>
                <tr *ngIf="rugOptionName(productItem, CARPET_ROLE_COLOUR) as colourName">
                  <td>{{carpetRoleLabelKey(CARPET_ROLE_COLOUR) | translate}}</td>
                  <td>{{colourName}}</td>
                </tr>
              </ng-container>
            </table>
          </div>
        </div>
        <p class="m-b-5 px-2 m-t-15">{{'doctrine.service_subject.description' | translate}}</p>
        <p class="px-2 ms-3">{{request.message}}</p>
        <table class="m-t-15 mx-2">
          <tr>
            <td width="150">{{'doctrine.service_request.subject' | translate}}</td>
            <td>
              <span>{{request.serviceSubject ? request.serviceSubject.name : request.subject }}</span>
              <span *ngIf="request.serviceSubjectItems?.length"> > </span>
              <span
                *ngFor="let Subject of request.serviceSubjectItems;let last = last; let index = index">{{Subject.name}} {{last ? '' : '>'}} </span>
            </td>
          </tr>
        </table>
        <table class="m-t-15 mx-2">
          <tr>
            <td width="150"></td>
            <td>
              <a
                *ngFor="let file of request.files"
                href="{{baseUrl + '/download?path=' + file.path + '&filename=' + file.filename}}"
                download="{{baseUrl + '/download?path=' + file.filename}}"
                class="btn btn-primary btn-file"
              >
                <span class="fa {{getFontAwesomeIconFromMIME(file.mimeType)}}"></span>
              </a>
            </td>
          </tr>
        </table>
      </div>
    </app-card>
    <app-manage-request-reply-dealer></app-manage-request-reply-dealer>
  </div>
  <div class="col-sm-4">
    <app-card [title]="'admin.service.request.view.status_title'|translate">
      <div *ngIf="request.order">
        <div class="row pb-2">
          <div class="col-6 font-weight-bold">{{'doctrine.attributes.order'|translate}}</div>
          <div class="col-6"><a class="order-link" [routerLink]="['/dealer-system/order', request.order.id, 'show']" target="_blank">{{request.order.orderNo}}<i class="fa fa-link ms-1"></i></a></div>
        </div>
        <div class="row pb-2">
          <div class="col-6 font-weight-bold">{{'doctrine.attributes.date'|translate}}</div>
          <div class="col-6">{{request.createdAt|DateFormat}}</div>
        </div>
        <div class="row pb-2">
          <div class="col-6 font-weight-bold">{{'doctrine.order.status'|translate}}</div>
          <div class="col-6">
            <span>
              {{(request.status ? request.status.translationKey : '-')|translate}}
            </span>
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-6 font-weight-bold">{{'doctrine.order.reference'|translate}}</div>
          <div class="col-6">{{request.order.reference}}</div>
        </div>
      </div>
    </app-card>
  </div>
</div>
